import { render, staticRenderFns } from "./CHistogram.vue?vue&type=template&id=31768041&scoped=true&"
import script from "./CHistogram.vue?vue&type=script&lang=js&"
export * from "./CHistogram.vue?vue&type=script&lang=js&"
import style0 from "./CHistogram.vue?vue&type=style&index=0&id=31768041&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31768041",
  null
  
)

export default component.exports